import { useCallback, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Dish, DishComponent } from '../../../apiTypes';
import DishComponentList from '../../../components/DishComponentList';
import { t } from '../../../constants/translations';
import { useLocale } from '../../../contexts/locale.context';
import EditCostsOfProducts from './EditCostsOfProducts';

type Props = {
  components: DishComponent[];
  form: UseFormReturn<Dish>;
  variationIndex: number;
  price: number;
  requiredComponents: DishComponent[];
  type: 'variations' | 'modifications';
};

const VariationComponents = ({ components, type, form, variationIndex, price, requiredComponents }: Props) => {
  const { lang } = useLocale();
  const [openEditCostsOfProducts, setOpenEditCostsOfProducts] = useState(false);

  const handleSubmit = useCallback(
    (value: DishComponent[]) => {
      form.setValue(`${type}.${variationIndex}.components`, value);
    },
    [form, type, variationIndex]
  );

  return (
    <>
      <DishComponentList
        components={components}
        onEdit={() => setOpenEditCostsOfProducts(true)}
        label={t.costs_of_production[lang]}
      />

      {openEditCostsOfProducts && (
        <EditCostsOfProducts
          open
          defaultComponents={components}
          price={price}
          onClose={() => setOpenEditCostsOfProducts(false)}
          onSubmit={handleSubmit}
          requiredComponents={requiredComponents}
          canBeNegative
        />
      )}
    </>
  );
};

export default VariationComponents;
